import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllCategories } from "../reducer/categorySlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const { categoryData } = useSelector(
    (state: any) => state.rootReducer.category
  );
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);

  useEffect(() => {
    store.dispatch(fetchAllCategories(null));
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  useEffect(() => {
    if (done) {
      store.dispatch(fetchAllCategories(null));
    }
  }, [done]);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
